import { useQuery } from '@tanstack/react-query';

import { SearchArchivedBatchesResponse } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  search: string;
}

const searchArchivedBatches = async ({ search }: HookProps): Promise<SearchArchivedBatchesResponse> => {
  try {
    const result = await apiClient.batchesArchive.searchArchivedBatches.query({ query: { search } });
    if (result.status !== 200) throw result.body;

    return result.body.data as SearchArchivedBatchesResponse;
  } catch (error) {
    showErrorToast(error, 'Failed to fetch the batch details');
  }
};

export const useSearchArchivedBatches = ({ search }: HookProps) =>
  useQuery({
    queryKey: ['archived-batches', search],
    queryFn: async () => searchArchivedBatches({ search }),
    enabled: !!search,
    placeholderData: [],
  });
